// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.donelogo{
  width: 200px;
}
.todo_user{
  width: 26px;
  /* border-radius: 100%; */
  height: 26px;
  padding-right: 0!important;
}
.name_Custum{
  padding: 10px;
  width:-webkit-fill-available;;
}
.custom-search-input{
     height: 38px;
    width: 450px!important;
    background-color: transparent;
    padding-left: 28px;
    border-right: solid 2px #cecccc;
}
.searchbox {
  background-color: transparent;
  border-radius: 28px;
  overflow: hidden;
  border: 3px solid #cecccc;
}
.search-border{
  height: 38px;
  
}
.button-green {
  /* background-color: #009345!important; */
  color: #009345;
  font-size: 13px;
  font-weight: 500;
  border-color: #009345;
 }
 .button-green:hover, .butn-green:hover {
  color:#009345 !important;
  border-color: #009345;
}
 .butn-green1{
  background-color: #009345!important;
  color: #fff;
  font-size: 14px;
 }
 .button-green1:hover, .butn-green1:hover {
  color:#fff !important;
  background-color: #009345!important;
}
.customedrop{
  box-shadow: 0 0 5px #4f494985;
  border: none;
  width: 185px;
  padding-bottom: 0;
  transform: translate(
    1440px
    , 
    59px
    ) !important;
    --bs-dropdown-link-active-bg: #f8f9fa !important;
    /* inset: auto auto auto auto !important; */
    width: unset;
    height: 100px;
    
}
.drop-down-item{
  border-bottom: 1px solid #0000003d;
  padding: 9px 17px 12px ;
  font-weight: 600 ;
  color: #454749 !important;
}
.profile-icon{
  color: #b3adadcc;
}
.drop-color{
color:  var(--bs-dropdown-link-color);;
}
.header-text p{
  font-size: 12px;
  border-bottom: 1px solid #5f5c5c;
  /* color: #bfbfbf !important; */
}
/* .to-head{
  background-color: #fbfbfb;
} */
.cart-icon{
  width: 50px;
}
.header-border{
  border-bottom: 1px solid #dedada73;
}
.request-btn{
  background-color: #67c119;
    color: #fff !important;
    padding: 3px 13px;
    border-radius: 5px;
    font-weight: 300;
}
.request-btn:hover{
  color: #fff !important;
}
/* .customedrop{
  --bs-dropdown-link-active-bg: #f8f9fa !important;
  
  width: unset;
  height: 100px;
} */
.signupform{
  height: 48px;
 margin: 8px 0; 
font-weight: 200;
  border: 1px solid #b4aeae;
  outline: none;
}
.signup-p{
  color: #2e2d2d;;
    font-size: 12px;
}
.login-btn{
  border: 1px solid #39a142 !important;
  height: 48px;
  width: 370px;
 color:#5c5a5a;
}
.signup1-p{
  font-size: 15px;
  color: #12b534;
}
.drop-position{
  position: relative;
}
.menu-position {
  position: absolute ; 
  right: 80px;
  top:34px;
}
.img-profile {
  background-color: #25373A;
  color: white;
  font-size: 18px;
}
.image-overflow{
  overflow-x: hidden;
}
.chat-icon{
  position: relative;
}
.chat-icon span{
position: absolute;   
right: 1px;
top: -3px;
color: white;
background-color: red;
width: 16px;
height: 16px;
    border-radius: 100%;
    text-align: center;
    font-size: 10px;
}
.signupform{
  width: 100%;
}
.modal-fade{
display: inline !important;
padding-left: 0% !important;
}
.login-btn{
  width: 100%;
} 
.butn-toggle::after{
  display: none;
}
.fixed-header{
  position: sticky;
  background: #ffffff;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
}
.menu-position ul{
  inset: unset !important;
  transform: none !important;
  border-color: floralwhite;
  box-shadow: 0 0 5px #4f494985;
  }
  .menu-positionli{
    color: #777272;
    font-weight: 500;
  }
  .menu-positionli:hover{
    color: #777272;
  }
  .menu-position .menu-positionli:focus,.menu-position .menu-positionli:active {
    background-color: transparent !important;
    outline: none; /* Remove the focus outline */
  }
  
  .menu-position .menu-positionli:focus:not([class^="dropdown-toggle"]),.menu-position .menu-positionli:active:not([class^="dropdown-toggle"]) {
    background-color: transparent !important;
    outline: none; /* Remove the focus outline */
  }
@media screen and (min-width: 320px) and (max-width: 576px){
  .response{
    display: flex;
    justify-content: center !important;
    padding-top: 8px;
  }
  .side-bar{
    padding-right: 3px;
  }
   .menu-position{
    position: absolute ;
     right: 165px ;
    } 
    .fixed-header{
      position: unset;
    }
 }
@media screen and (max-width: 340px) {
  .butn-green1{
    font-size: 12px;
  }
  .button-green{
    font-size: 10px;
    }

}
@media screen and (min-width: 992px) and (max-width: 1140px){
  .donelogo {
    width: 155px;
   padding-left: 8px;
}
.header-text p {
  font-size: 8px !important;
  margin-right: 4px !important;
}
.button-green{
  font-size: 10px;
  padding: 5px !important;
  }
  .response{
    display: flex;
    justify-content: space-evenly;
    padding-top: 8px;
  }
  .butn-green1{
    font-size: 12px;
    padding-left: 6px !important;
  }
  .header-border{
padding: 0px 8px 0px 8px;
  }
  .menu-position{
    position: absolute ;
     right: 174x ;
    } 
}
@media screen and (min-width: 1141px) and (max-width: 1439px){
  .response{
    display: flex;
    justify-content: space-evenly;
    padding-top: 8px;
  }
  .donelogo {
    width: 170px;
}
.butn-green1{
padding-left: 6px !important;
}
.button-green{
  font-size: 10px;
  }
  .menu-position{
    position: absolute ;
     right: 157px ;
    } 
}
@media screen and (max-width: 767px) ,screen and (min-width: 768px) and (max-width: 991px)  {
  .header-text{
    display: none;
  }
  .drop-position{
    position: relative;
  }
  .donelogo{
width: 153px;
  }
}
@media screen and   (min-width: 1440px) {
  .header-text p {
    font-size: 14px;
  }
    .response-right{
      padding-right: 0px !important;
    }
    .menu-position{
      position: absolute ;
       right: 178px ;
      } 
  }
  @media (max-width: 576px) {
    .customedrop {
      width: 70px !important;
      height: 100px !important;
    }
    .name_Custum{
     margin-left: 14px;
     font-size: 14px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Components/header/Header.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,4BAA4B;AAC9B;AACA;KACK,YAAY;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,+BAA+B;AACnC;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;;AAEd;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;CACtB;CACA;EACC,wBAAwB;EACxB,qBAAqB;AACvB;CACC;EACC,mCAAmC;EACnC,WAAW;EACX,eAAe;CAChB;CACA;EACC,qBAAqB;EACrB,mCAAmC;AACrC;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB;;;;gBAIc;IACZ,gDAAgD;IAChD,2CAA2C;IAC3C,YAAY;IACZ,aAAa;;AAEjB;AACA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;AACA,qCAAqC;AACrC;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,+BAA+B;AACjC;AACA;;GAEG;AACH;EACE,WAAW;AACb;AACA;EACE,kCAAkC;AACpC;AACA;EACE,yBAAyB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;;;;;GAKG;AACH;EACE,YAAY;CACb,aAAa;AACd,gBAAgB;EACd,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,cAAc;IACZ,eAAe;AACnB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;CACb,aAAa;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;AACA,kBAAkB;AAClB,UAAU;AACV,SAAS;AACT,YAAY;AACZ,qBAAqB;AACrB,WAAW;AACX,YAAY;IACR,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;EACE,WAAW;AACb;AACA;AACA,0BAA0B;AAC1B,2BAA2B;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,MAAM;EACN,OAAO;EACP,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,wCAAwC;IACxC,aAAa,EAAE,6BAA6B;EAC9C;;EAEA;IACE,wCAAwC;IACxC,aAAa,EAAE,6BAA6B;EAC9C;AACF;EACE;IACE,aAAa;IACb,kCAAkC;IAClC,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;GACC;IACC,mBAAmB;KAClB,aAAa;IACd;IACA;MACE,eAAe;IACjB;CACH;AACD;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf;;AAEJ;AACA;EACE;IACE,YAAY;GACb,iBAAiB;AACpB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,uBAAuB;EACvB;EACA;IACE,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,4BAA4B;EAC9B;EACA;AACF,wBAAwB;EACtB;EACA;IACE,mBAAmB;KAClB,YAAY;IACb;AACJ;AACA;EACE;IACE,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,YAAY;AAChB;AACA;AACA,4BAA4B;AAC5B;AACA;EACE,eAAe;EACf;EACA;IACE,mBAAmB;KAClB,aAAa;IACd;AACJ;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;AACF,YAAY;EACV;AACF;AACA;EACE;IACE,eAAe;EACjB;IACE;MACE,6BAA6B;IAC/B;IACA;MACE,mBAAmB;OAClB,aAAa;MACd;EACJ;EACA;IACE;MACE,sBAAsB;MACtB,wBAAwB;IAC1B;IACA;KACC,iBAAiB;KACjB,eAAe;IAChB;EACF","sourcesContent":[".donelogo{\n  width: 200px;\n}\n.todo_user{\n  width: 26px;\n  /* border-radius: 100%; */\n  height: 26px;\n  padding-right: 0!important;\n}\n.name_Custum{\n  padding: 10px;\n  width:-webkit-fill-available;;\n}\n.custom-search-input{\n     height: 38px;\n    width: 450px!important;\n    background-color: transparent;\n    padding-left: 28px;\n    border-right: solid 2px #cecccc;\n}\n.searchbox {\n  background-color: transparent;\n  border-radius: 28px;\n  overflow: hidden;\n  border: 3px solid #cecccc;\n}\n.search-border{\n  height: 38px;\n  \n}\n.button-green {\n  /* background-color: #009345!important; */\n  color: #009345;\n  font-size: 13px;\n  font-weight: 500;\n  border-color: #009345;\n }\n .button-green:hover, .butn-green:hover {\n  color:#009345 !important;\n  border-color: #009345;\n}\n .butn-green1{\n  background-color: #009345!important;\n  color: #fff;\n  font-size: 14px;\n }\n .button-green1:hover, .butn-green1:hover {\n  color:#fff !important;\n  background-color: #009345!important;\n}\n.customedrop{\n  box-shadow: 0 0 5px #4f494985;\n  border: none;\n  width: 185px;\n  padding-bottom: 0;\n  transform: translate(\n    1440px\n    , \n    59px\n    ) !important;\n    --bs-dropdown-link-active-bg: #f8f9fa !important;\n    /* inset: auto auto auto auto !important; */\n    width: unset;\n    height: 100px;\n    \n}\n.drop-down-item{\n  border-bottom: 1px solid #0000003d;\n  padding: 9px 17px 12px ;\n  font-weight: 600 ;\n  color: #454749 !important;\n}\n.profile-icon{\n  color: #b3adadcc;\n}\n.drop-color{\ncolor:  var(--bs-dropdown-link-color);;\n}\n.header-text p{\n  font-size: 12px;\n  border-bottom: 1px solid #5f5c5c;\n  /* color: #bfbfbf !important; */\n}\n/* .to-head{\n  background-color: #fbfbfb;\n} */\n.cart-icon{\n  width: 50px;\n}\n.header-border{\n  border-bottom: 1px solid #dedada73;\n}\n.request-btn{\n  background-color: #67c119;\n    color: #fff !important;\n    padding: 3px 13px;\n    border-radius: 5px;\n    font-weight: 300;\n}\n.request-btn:hover{\n  color: #fff !important;\n}\n/* .customedrop{\n  --bs-dropdown-link-active-bg: #f8f9fa !important;\n  \n  width: unset;\n  height: 100px;\n} */\n.signupform{\n  height: 48px;\n margin: 8px 0; \nfont-weight: 200;\n  border: 1px solid #b4aeae;\n  outline: none;\n}\n.signup-p{\n  color: #2e2d2d;;\n    font-size: 12px;\n}\n.login-btn{\n  border: 1px solid #39a142 !important;\n  height: 48px;\n  width: 370px;\n color:#5c5a5a;\n}\n.signup1-p{\n  font-size: 15px;\n  color: #12b534;\n}\n.drop-position{\n  position: relative;\n}\n.menu-position {\n  position: absolute ; \n  right: 80px;\n  top:34px;\n}\n.img-profile {\n  background-color: #25373A;\n  color: white;\n  font-size: 18px;\n}\n.image-overflow{\n  overflow-x: hidden;\n}\n.chat-icon{\n  position: relative;\n}\n.chat-icon span{\nposition: absolute;   \nright: 1px;\ntop: -3px;\ncolor: white;\nbackground-color: red;\nwidth: 16px;\nheight: 16px;\n    border-radius: 100%;\n    text-align: center;\n    font-size: 10px;\n}\n.signupform{\n  width: 100%;\n}\n.modal-fade{\ndisplay: inline !important;\npadding-left: 0% !important;\n}\n.login-btn{\n  width: 100%;\n} \n.butn-toggle::after{\n  display: none;\n}\n.fixed-header{\n  position: sticky;\n  background: #ffffff;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n}\n.menu-position ul{\n  inset: unset !important;\n  transform: none !important;\n  border-color: floralwhite;\n  box-shadow: 0 0 5px #4f494985;\n  }\n  .menu-positionli{\n    color: #777272;\n    font-weight: 500;\n  }\n  .menu-positionli:hover{\n    color: #777272;\n  }\n  .menu-position .menu-positionli:focus,.menu-position .menu-positionli:active {\n    background-color: transparent !important;\n    outline: none; /* Remove the focus outline */\n  }\n  \n  .menu-position .menu-positionli:focus:not([class^=\"dropdown-toggle\"]),.menu-position .menu-positionli:active:not([class^=\"dropdown-toggle\"]) {\n    background-color: transparent !important;\n    outline: none; /* Remove the focus outline */\n  }\n@media screen and (min-width: 320px) and (max-width: 576px){\n  .response{\n    display: flex;\n    justify-content: center !important;\n    padding-top: 8px;\n  }\n  .side-bar{\n    padding-right: 3px;\n  }\n   .menu-position{\n    position: absolute ;\n     right: 165px ;\n    } \n    .fixed-header{\n      position: unset;\n    }\n }\n@media screen and (max-width: 340px) {\n  .butn-green1{\n    font-size: 12px;\n  }\n  .button-green{\n    font-size: 10px;\n    }\n\n}\n@media screen and (min-width: 992px) and (max-width: 1140px){\n  .donelogo {\n    width: 155px;\n   padding-left: 8px;\n}\n.header-text p {\n  font-size: 8px !important;\n  margin-right: 4px !important;\n}\n.button-green{\n  font-size: 10px;\n  padding: 5px !important;\n  }\n  .response{\n    display: flex;\n    justify-content: space-evenly;\n    padding-top: 8px;\n  }\n  .butn-green1{\n    font-size: 12px;\n    padding-left: 6px !important;\n  }\n  .header-border{\npadding: 0px 8px 0px 8px;\n  }\n  .menu-position{\n    position: absolute ;\n     right: 174x ;\n    } \n}\n@media screen and (min-width: 1141px) and (max-width: 1439px){\n  .response{\n    display: flex;\n    justify-content: space-evenly;\n    padding-top: 8px;\n  }\n  .donelogo {\n    width: 170px;\n}\n.butn-green1{\npadding-left: 6px !important;\n}\n.button-green{\n  font-size: 10px;\n  }\n  .menu-position{\n    position: absolute ;\n     right: 157px ;\n    } \n}\n@media screen and (max-width: 767px) ,screen and (min-width: 768px) and (max-width: 991px)  {\n  .header-text{\n    display: none;\n  }\n  .drop-position{\n    position: relative;\n  }\n  .donelogo{\nwidth: 153px;\n  }\n}\n@media screen and   (min-width: 1440px) {\n  .header-text p {\n    font-size: 14px;\n  }\n    .response-right{\n      padding-right: 0px !important;\n    }\n    .menu-position{\n      position: absolute ;\n       right: 178px ;\n      } \n  }\n  @media (max-width: 576px) {\n    .customedrop {\n      width: 70px !important;\n      height: 100px !important;\n    }\n    .name_Custum{\n     margin-left: 14px;\n     font-size: 14px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
